import React, { useEffect, useState } from 'react';
import { Box, Typography, Grid, Card, CardContent, Avatar } from '@mui/material';
import axiosInstance from '../../api/axiosPublic';
import { getRootSubdomain } from '../utils/subdomain';



const WebTestimonials = () => {
  const [testimonials, setTestimonials] = useState([]);
  const tenantKey = getRootSubdomain();

  useEffect(() => {
    if (!tenantKey) {
      window.location.href = '/hello';
      return;
    }

    const fetchTestimonials = async () => {
      try {
        const response = await axiosInstance.get(`/api/${tenantKey}/testimonials`);
        setTestimonials(response.data);
      } catch (error) {
        console.error('Error fetching testimonials:', error);
      }
    };
    fetchTestimonials();
  }, [tenantKey]);

  return (
    <Box sx={{ py: 8 }}>
      <Typography variant="h4" align="center" gutterBottom>
        What Our Students Say
      </Typography>
      <Grid container spacing={4} justifyContent="center">
        {testimonials.map((testimonial) => (
          <Grid item xs={12} sm={6} md={4} key={testimonial.id}>
            <Card sx={{ padding: 2, height: '100%' }}>
              <CardContent>
                <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                  <Avatar
                    alt={testimonial.name}
                    src={testimonial.avatar || '/path-to-default-avatar.jpg'}
                    sx={{ mr: 2 }}
                  />
                  <Typography variant="h6">{testimonial.name}</Typography>
                </Box>
                <Typography variant="body2" color="text.secondary">
                  "{testimonial.message}"
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default WebTestimonials;
